import React from 'react'

import { useCanary } from '@bill/canary.react'
import useNameFormatter from '@divvy-web/hooks.usenameformatter'

import MaintenanceScreen from './MaintenanceScreen'
import styles from './styles.module.scss'

export const Root = ({ children }: React.PropsWithChildren) => {
  const [getClassName] = useNameFormatter('Root')

  const maintMode = useCanary('sputnik-maint-mode')

  if (maintMode) return <MaintenanceScreen />

  return (
    <div
      className={styles[getClassName('')]}
      data-testid='root'
      id='main-content'
    >
      {children}
    </div>
  )
}
